import { compose, defaultProps, withProps } from "recompact"
import { connect } from "react-redux"
import planTypeModel from "src/models/planType"
import entityList from "src/hocs/entityList"
import EntityListEditor from "src/components/EntityListEditor"
import Constraints from "src/components/PlanConstraints"
import {
  PLAN_TYPE_CREATE,
  PLAN_TYPE_UPDATE,
  PLAN_TYPE_DELETE,
} from "src/constants/knownPermissions"
import {
  PLAN_TYPES_URL,
  PLAN_TYPES_ID_MAIN_URL,
  PLAN_TYPES_ID_CONSTRAINT_URL,
} from "src/constants/routeNames"
import entityApi from "src/hocs/entity"
import queryString from "query-string"
import { hasPermission } from "src/engine/modules/currentUser"
import React from "react"
import Item, { FORM_NAME } from "./Item"

const durationUnits = {
  DAY: `дн.`,
  WEEK: `нед.`,
  MONTH: `мес.`,
  YEAR: `г.`,
}

const columns = [
  {
    Header: `Наименование типа плана`,
    accessor: `name`,
    sortable: true,
  },
  {
    Header: `Длительность типа плана`,
    accessor: `defaultPlanDurationUnit`,
    sortable: false,
    Cell: ({
      original: { defaultPlanDurationUnit, defaultPlanDurationValue },
    }) => (
      <div>{`${defaultPlanDurationValue} ${durationUnits[defaultPlanDurationUnit]}`}</div>
    ),
  },
]

const enhancer = compose(
  entityList({
    model: planTypeModel,
    ITEM_FORM_NAME: FORM_NAME,
    baseUri: PLAN_TYPES_URL,
    columns,
  }),
  withProps(
    props => props.match.params.id !== `new` && { id: props.match.params.id },
  ),
  entityApi({
    to: `planType`,
    model: planTypeModel,
    onCreate: ({ history, queryParams }) => ({ id }) => {
      history.push(
        `${PLAN_TYPES_URL}/${id}/main?${queryString.stringify(queryParams)}`,
      )
    },
  }),
  defaultProps({
    isOnlySearchInputFilter: true,
    tabConfig: {
      createTitle: `Создание типа плана`,
      editTitle: `Редактирование типа плана`,
      basicUrl: `/plan/types/`,
      closeUrl: PLAN_TYPES_URL,
      tabs: [
        {
          name: `Общая информация`,
          to: PLAN_TYPES_ID_MAIN_URL,
          id: `main`,
          component: connect(state => ({
            disableEdit: !hasPermission(PLAN_TYPE_UPDATE)(state),
          }))(Item),
        },
        {
          name: `Ограничения`,
          to: PLAN_TYPES_ID_CONSTRAINT_URL,
          id: `constraint`,
          component: connect(state => ({
            disableEdit: !hasPermission(PLAN_TYPE_UPDATE)(state),
          }))(Constraints),
        },
      ],
    },
  }),
  connect(state => ({
    disableCreate: !hasPermission(PLAN_TYPE_CREATE)(state),
    disableEdit: !hasPermission(PLAN_TYPE_UPDATE)(state),
    disableDelete: !hasPermission(PLAN_TYPE_DELETE)(state),
  })),
  withProps(({ planType }) => ({ dataForTabs: { planType } })),
)

export default enhancer(EntityListEditor)
